import GroupsIcon from "@mui/icons-material/Groups";
import { Avatar } from "@mui/material";

type Props = {
  /** Channel image when one is set; the icon shows in its absence (our groups have none today). */
  image?: string;
  name: string;
};

/**
 * Avatar of a group channel: one group icon rather than the channel's initial, which reads as a
 * person and makes a group indistinguishable from a photo-less DM. Sized to match the DM avatar
 * so list rows keep a single height.
 */
export const ChatGroupAvatar = ({ image, name }: Props) => (
  <Avatar
    src={image}
    alt={name}
    sx={({ palette }) => ({
      width: 40,
      height: 40,
      bgcolor: palette.primary.main,
    })}
  >
    <GroupsIcon />
  </Avatar>
);
